/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getMetrics = /* GraphQL */ `
  query GetMetrics($metric_date_range_list: String!) {
    getMetrics(metric_date_range_list: $metric_date_range_list) {
      code
      success
      message
      body {
        clients
        spokes
        channels
        received_messages
        queued_messages
        filtered_messages
        errored_messages
        sent_messages
        last_calculated
        mcc_system_status
        __typename
      }
      __typename
    }
  }
`;
export const getAvailableSpokes = /* GraphQL */ `
  query GetAvailableSpokes {
    getAvailableSpokes {
      code
      success
      message
      body {
        spoke_id
        spoke_name
        spoke_type
        region
        api_request_url
        api_role
        aws_account
        ecr_repo
        __typename
      }
      __typename
    }
  }
`;
export const getClients = /* GraphQL */ `
  query GetClients(
    $metric_date_range_list: String!
    $is_active: Boolean
    $client_ids: [String]
    $sap_ids: [String]
    $env_type_value: String
    $sortFilter: String
    $sortType: SortType
    $limit: Int
    $offSet: Int
  ) {
    getClients(
      metric_date_range_list: $metric_date_range_list
      is_active: $is_active
      client_ids: $client_ids
      sap_ids: $sap_ids
      env_type_value: $env_type_value
      sortFilter: $sortFilter
      sortType: $sortType
      limit: $limit
      offSet: $offSet
    ) {
      code
      success
      message
      body {
        clientsData {
          active
          client_id
          client_name
          spokes
          client_environments
          internal_environments
          external_environments
          external_client_id
          channels
          queued_messages
          received_messages
          sent_messages
          errored_messages
          filtered_messages
          client_status
          last_calculated
          avg_process_time
          __typename
        }
        totalCount
        __typename
      }
      __typename
    }
  }
`;
export const getClient = /* GraphQL */ `
  query GetClient(
    $client_id: String!
    $metric_date_range_list: String!
    $is_active: Boolean
    $client_environment_ids: [String]
    $sortFilter: String
    $sortType: SortType
    $limit: Int
    $offSet: Int
  ) {
    getClient(
      client_id: $client_id
      metric_date_range_list: $metric_date_range_list
      is_active: $is_active
      client_environment_ids: $client_environment_ids
      sortFilter: $sortFilter
      sortType: $sortType
      limit: $limit
      offSet: $offSet
    ) {
      code
      success
      message
      body {
        client_id
        client_name
        client_status
        client_environments_body {
          client_environments {
            client_environment_id
            client_environment_name
            active
            deploy_status
            suppress_support_event
            updated_at
            created_at
            channels_count
            spoke_id
            spoke_name
            spoke_type
            api_request_url
            api_role
            region
            aws_account
            received_messages
            queued_messages
            filtered_messages
            sent_messages
            errored_messages
            avg_process_time
            client_environment_status
            last_calculated
            __typename
          }
          total_count
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const getChannelMessageStorage = /* GraphQL */ `
  query GetChannelMessageStorage(
    $channel_id: String!
    $client_environment_id: String!
    $client_id: String!
  ) {
    getChannelMessageStorage(
      channel_id: $channel_id
      client_environment_id: $client_environment_id
      client_id: $client_id
    ) {
      code
      success
      message
      body {
        data {
          client_environment_id
          environment_name
          channel_id
          channel_name
          s3_archive_date1
          s3_archive_date2
          s3_usage_bytes_date_1
          s3_usage_bytes_date_2
          date_inserted
          __typename
        }
        total_count
        client_env_details {
          client_id
          client_name
          __typename
        }
        storage_summary {
          total_current_gb
          total_previous_gb
          __typename
        }
        entitlement_info {
          has_entitlement
          allotment_gb
          entitlement_id
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const getClientEnvironmentMessageStorage = /* GraphQL */ `
  query GetClientEnvironmentMessageStorage(
    $client_environment_id: String!
    $client_id: String!
    $date1: String!
    $date2: String
  ) {
    getClientEnvironmentMessageStorage(
      client_environment_id: $client_environment_id
      client_id: $client_id
      date1: $date1
      date2: $date2
    ) {
      code
      success
      message
      body {
        data {
          client_environment_id
          environment_name
          channel_id
          channel_name
          s3_archive_date1
          s3_archive_date2
          s3_usage_bytes_date_1
          s3_usage_bytes_date_2
          date_inserted
          __typename
        }
        total_count
        client_env_details {
          client_id
          client_name
          __typename
        }
        storage_summary {
          total_current_gb
          total_previous_gb
          __typename
        }
        entitlement_info {
          has_entitlement
          allotment_gb
          entitlement_id
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const getClientMessageStorage = /* GraphQL */ `
  query GetClientMessageStorage(
    $client_id: String!
    $date1: String!
    $date2: String
  ) {
    getClientMessageStorage(
      client_id: $client_id
      date1: $date1
      date2: $date2
    ) {
      code
      success
      message
      body {
        data {
          client_environment_id
          environment_name
          channel_id
          channel_name
          s3_archive_date1
          s3_archive_date2
          s3_usage_bytes_date_1
          s3_usage_bytes_date_2
          date_inserted
          __typename
        }
        total_count
        client_env_details {
          client_id
          client_name
          __typename
        }
        storage_summary {
          total_current_gb
          total_previous_gb
          __typename
        }
        entitlement_info {
          has_entitlement
          allotment_gb
          entitlement_id
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const addClient = /* GraphQL */ `
  query AddClient(
    $sap_id: String
    $client_name: String!
    $keygen_id: String
    $keygen_key: String
    $keygen_name: String
  ) {
    addClient(
      sap_id: $sap_id
      client_name: $client_name
      keygen_id: $keygen_id
      keygen_key: $keygen_key
      keygen_name: $keygen_name
    ) {
      code
      success
      message
      body {
        response
        client_id
        __typename
      }
      __typename
    }
  }
`;
export const addClientEnvironment = /* GraphQL */ `
  query AddClientEnvironment(
    $client_id: String!
    $client_environment_name: String!
    $spoke_id: String!
    $ecr_image_uri: String!
    $expected_client_size: ExpectedClientSize!
    $mc_license_key: String!
    $client_environment_threshold: String
  ) {
    addClientEnvironment(
      client_id: $client_id
      client_environment_name: $client_environment_name
      spoke_id: $spoke_id
      ecr_image_uri: $ecr_image_uri
      expected_client_size: $expected_client_size
      mc_license_key: $mc_license_key
      client_environment_threshold: $client_environment_threshold
    ) {
      code
      success
      message
      body {
        response
        __typename
      }
      __typename
    }
  }
`;
export const getClientEnvironment = /* GraphQL */ `
  query GetClientEnvironment(
    $client_id: String!
    $client_environment_id: String!
    $metric_date_range_list: String!
    $is_active: Boolean
    $is_favorite: Boolean
    $is_entitled: Boolean
    $is_inactive: Boolean
    $channel_ids: [String]
    $sortFilter: String
    $sortType: SortType
    $limit: Int
    $offSet: Int
  ) {
    getClientEnvironment(
      client_id: $client_id
      client_environment_id: $client_environment_id
      metric_date_range_list: $metric_date_range_list
      is_active: $is_active
      is_favorite: $is_favorite
      is_entitled: $is_entitled
      is_inactive: $is_inactive
      channel_ids: $channel_ids
      sortFilter: $sortFilter
      sortType: $sortType
      limit: $limit
      offSet: $offSet
    ) {
      code
      success
      message
      body {
        client_environment_data {
          client_id
          client_name
          client_environment_id
          client_environment_name
          spoke_id
          spoke_name
          spoke_type
          region
          api_request_url
          api_role
          aws_account
          deploy_status
          client_environment_status
          channels {
            channel_id
            channel_status
            suppress_support_event
            channel_name
            channel_group_name
            mc_auth_type
            received_messages
            sent_messages
            errored_messages
            filtered_messages
            queued_messages
            last_reviewed_by_support
            support_tier
            avg_process_time
            last_calculated
            channel_library_id
            mc_protocol
            mcc_channel_type
            enabled
            is_favorite
            __typename
          }
          __typename
        }
        total_channel_count
        __typename
      }
      __typename
    }
  }
`;
export const getList = /* GraphQL */ `
  query GetList(
    $type: ResourceType!
    $auth_client_id: String
    $id: String
    $is_active: Boolean
  ) {
    getList(
      type: $type
      auth_client_id: $auth_client_id
      id: $id
      is_active: $is_active
    ) {
      code
      success
      message
      body {
        id
        name
        env
        spoke_type
        sap_id
        hash {
          value
          label
          env
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const getInboundMessages = /* GraphQL */ `
  query GetInboundMessages(
    $clientEnvironmentId: String!
    $channelId: String!
    $msgId: String!
    $msgStatus: String!
    $startDate: String!
    $endDate: String!
    $tokenData: String!
    $offSet: Int
    $limit: Int
    $sortFilter: String
    $sortType: SortType
  ) {
    getInboundMessages(
      clientEnvironmentId: $clientEnvironmentId
      channelId: $channelId
      msgId: $msgId
      msgStatus: $msgStatus
      startDate: $startDate
      endDate: $endDate
      tokenData: $tokenData
      offSet: $offSet
      limit: $limit
      sortFilter: $sortFilter
      sortType: $sortType
    ) {
      code
      success
      message
      body {
        inboundMessages {
          msg_id
          message_data_available
          raw_message_bytes
          date_received
          inbound_message_idempotency_key
          error_total
          sent_total
          filter_total
          __typename
        }
        totalCount
        __typename
      }
      __typename
    }
  }
`;
export const getSupportEvents = /* GraphQL */ `
  query GetSupportEvents(
    $start_date: String
    $end_date: String
    $event_status: String
    $spoke_ids: [String]
    $client_ids: [String]
    $environment_ids: [String]
    $event_types: [String]
    $offSet: Int
    $limit: Int
    $sortFilter: String
    $sortType: SortType
  ) {
    getSupportEvents(
      start_date: $start_date
      end_date: $end_date
      event_status: $event_status
      spoke_ids: $spoke_ids
      client_ids: $client_ids
      environment_ids: $environment_ids
      event_types: $event_types
      offSet: $offSet
      limit: $limit
      sortFilter: $sortFilter
      sortType: $sortType
    ) {
      code
      success
      message
      body {
        support_event_data {
          support_event_idempotency_key
          support_event_correlation_id
          client_id
          client_name
          channel_id
          channel_name
          event_type
          event_label
          event_start
          event_end
          event_raised_by
          event_resolved_by
          aws_namespace
          aws_name
          spoke_id
          spoke_name
          client_environment_id
          client_environment_name
          severity
          __typename
        }
        total_count
        __typename
      }
      __typename
    }
  }
`;
export const addSupportEventDetail = /* GraphQL */ `
  query AddSupportEventDetail(
    $support_event_idempotency_key: String!
    $support_event_correlation_id: String!
    $client_id: String
    $client_environment_id: String
    $channel_id: String
    $channel_name: String
    $event_type: String!
    $event_label: String
    $eval_date: String!
    $event_comments: String!
    $email_id: String!
  ) {
    addSupportEventDetail(
      support_event_idempotency_key: $support_event_idempotency_key
      support_event_correlation_id: $support_event_correlation_id
      client_id: $client_id
      client_environment_id: $client_environment_id
      channel_id: $channel_id
      channel_name: $channel_name
      event_type: $event_type
      event_label: $event_label
      eval_date: $eval_date
      event_comments: $event_comments
      email_id: $email_id
    ) {
      code
      success
      message
      body {
        response
        __typename
      }
      __typename
    }
  }
`;
export const getSupportEventDetails = /* GraphQL */ `
  query GetSupportEventDetails(
    $client_environment_id: String
    $support_event_idempotency_key: String!
    $event_type: String!
    $start_date: String
    $end_date: String
    $offSet: Int
    $limit: Int
    $sortFilter: String
    $sortType: SortType
  ) {
    getSupportEventDetails(
      client_environment_id: $client_environment_id
      support_event_idempotency_key: $support_event_idempotency_key
      event_type: $event_type
      start_date: $start_date
      end_date: $end_date
      offSet: $offSet
      limit: $limit
      sortFilter: $sortFilter
      sortType: $sortType
    ) {
      code
      success
      message
      body {
        support_event_data {
          support_event {
            support_event_idempotency_key
            support_event_correlation_id
            client_id
            client_name
            channel_id
            channel_name
            event_type
            event_label
            event_start
            event_end
            event_raised_by
            event_resolved_by
            aws_namespace
            aws_name
            spoke_id
            spoke_name
            client_environment_id
            client_environment_name
            severity
            __typename
          }
          support_event_details {
            support_event_detail_id
            event_comments
            eval_date
            user_id
            __typename
          }
          __typename
        }
        total_count
        __typename
      }
      __typename
    }
  }
`;
export const addSupportEvents = /* GraphQL */ `
  query AddSupportEvents(
    $support_event_idempotency_key: String!
    $support_event_correlation_id: String!
    $client_id: String
    $client_environment_id: String
    $channel_id: String
    $channel_name: String
    $event_description: String!
    $event_start: String!
    $event_end: String
    $event_raised_by: String!
    $event_resolved_by: String
    $aws_account: String
    $aws_namespace: String
    $aws_name: String
    $event_type: String!
    $event_label: String!
    $email_id: String
  ) {
    addSupportEvents(
      support_event_idempotency_key: $support_event_idempotency_key
      support_event_correlation_id: $support_event_correlation_id
      client_id: $client_id
      client_environment_id: $client_environment_id
      channel_id: $channel_id
      channel_name: $channel_name
      event_description: $event_description
      event_start: $event_start
      event_end: $event_end
      event_raised_by: $event_raised_by
      event_resolved_by: $event_resolved_by
      aws_account: $aws_account
      aws_namespace: $aws_namespace
      aws_name: $aws_name
      event_type: $event_type
      event_label: $event_label
      email_id: $email_id
    ) {
      code
      success
      message
      body {
        response
        __typename
      }
      __typename
    }
  }
`;
export const addMultipleReprocess = /* GraphQL */ `
  query AddMultipleReprocess(
    $clientEnvironmentId: String!
    $channelId: String!
    $idempotencyKeyArray: String!
  ) {
    addMultipleReprocess(
      clientEnvironmentId: $clientEnvironmentId
      channelId: $channelId
      idempotencyKeyArray: $idempotencyKeyArray
    ) {
      code
      success
      message
      body {
        response
        __typename
      }
      __typename
    }
  }
`;
export const processChannelMessage = /* GraphQL */ `
  query ProcessChannelMessage(
    $client_environment_id: String!
    $channel_id: String!
    $idempotency_key: String
    $message_data: String
  ) {
    processChannelMessage(
      client_environment_id: $client_environment_id
      channel_id: $channel_id
      idempotency_key: $idempotency_key
      message_data: $message_data
    ) {
      code
      success
      message
      body {
        response
        __typename
      }
      __typename
    }
  }
`;
export const getTokenTypes = /* GraphQL */ `
  query GetTokenTypes($token_request: String!) {
    getTokenTypes(token_request: $token_request) {
      code
      success
      message
      body {
        token_type
        __typename
      }
      __typename
    }
  }
`;
export const getS3DataForInboundMessages = /* GraphQL */ `
  query GetS3DataForInboundMessages(
    $inboundMessageIdempotencyKey: String!
    $clientEnvironmentId: String!
    $channelId: String!
    $messageId: String!
  ) {
    getS3DataForInboundMessages(
      inboundMessageIdempotencyKey: $inboundMessageIdempotencyKey
      clientEnvironmentId: $clientEnvironmentId
      channelId: $channelId
      messageId: $messageId
    ) {
      code
      success
      message
      body {
        channel_data {
          client_name
          client_environment_name
          channel_name
          __typename
        }
        s3_data
        connector_data {
          connector_id
          connector_name
          connector_msg_status
          connector_error_text
          connector_date_processed
          process_time_sec
          __typename
        }
        search_token_data {
          search_token_key
          search_token_value
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const getConnectorDetail = /* GraphQL */ `
  query GetConnectorDetail(
    $clientId: String!
    $clientEnvironmentId: String!
    $channelId: String!
    $startDate: String!
    $endDate: String!
  ) {
    getConnectorDetail(
      clientId: $clientId
      clientEnvironmentId: $clientEnvironmentId
      channelId: $channelId
      startDate: $startDate
      endDate: $endDate
    ) {
      code
      success
      message
      body {
        channel_name
        connectors {
          connector_id
          connector_name
          channel_name
          sent_total
          error_total
          filtered_total
          avg_process_time
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const getChannel = /* GraphQL */ `
  query GetChannel(
    $clientId: String!
    $clientEnvironmentId: String!
    $channelId: String!
    $startDate: String!
    $endDate: String!
    $sortFilter: String
    $sortType: SortType
  ) {
    getChannel(
      clientId: $clientId
      clientEnvironmentId: $clientEnvironmentId
      channelId: $channelId
      startDate: $startDate
      endDate: $endDate
      sortFilter: $sortFilter
      sortType: $sortType
    ) {
      code
      success
      message
      body {
        channel_id
        channel_name
        queued_messages
        received_messages
        sent_messages
        errored_messages
        filtered_messages
        weighted_avg_process_time_sec
        weighted_avg_source_finished_to_message_finished_process_time_sec
        weighted_avg_message_minus_destination_queues_process_time_sec
        weighted_avg_raw_message_size_bytes
        weighted_avg_attachment_size_bytes
        connectors {
          connector_id
          name
          type
          active
          position
          updated_on
          count
          weighted_avg_dispatch_process_time_sec
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const getEnvironmentResourceDetails = /* GraphQL */ `
  query GetEnvironmentResourceDetails($clientEnvironmentId: String!) {
    getEnvironmentResourceDetails(clientEnvironmentId: $clientEnvironmentId) {
      code
      success
      message
      body {
        db_secrets {
          key
          value
          __typename
        }
        mc_secrets {
          key
          value
          __typename
        }
        mc_nlb_dns_name
        mc_authorized_data_sources {
          api_key
          routes
          user_name
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const getAvailablePorts = /* GraphQL */ `
  query GetAvailablePorts($clientEnvironmentId: String!) {
    getAvailablePorts(clientEnvironmentId: $clientEnvironmentId) {
      code
      success
      message
      body {
        available_ports
        __typename
      }
      __typename
    }
  }
`;
export const getEnvironmentConfiguration = /* GraphQL */ `
  query GetEnvironmentConfiguration($clientEnvironmentId: String!) {
    getEnvironmentConfiguration(clientEnvironmentId: $clientEnvironmentId) {
      code
      success
      message
      body {
        response
        client_environment_threshold {
          mc_prune_enabled
          mc_polling_type
          mc_polling_frequency_min
          mc_polling_frequency_max
          mc_all_day
          mc_starting_hour
          mc_ending_hour
          mc_prune_events
          mc_prune_event_age
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const updateEnvironment = /* GraphQL */ `
  query UpdateEnvironment(
    $client_environment_id: String!
    $environment_json: String!
    $previously_updated_at: String!
    $client_environment_threshold: String
    $threshold_details_changed: Boolean
    $environment_configuration_changed: Boolean
  ) {
    updateEnvironment(
      client_environment_id: $client_environment_id
      environment_json: $environment_json
      previously_updated_at: $previously_updated_at
      client_environment_threshold: $client_environment_threshold
      threshold_details_changed: $threshold_details_changed
      environment_configuration_changed: $environment_configuration_changed
    ) {
      code
      success
      message
      body {
        response
        __typename
      }
      __typename
    }
  }
`;
export const updateChannel = /* GraphQL */ `
  query UpdateChannel(
    $client_environment_id: String!
    $update_channels_list: String
    $add_channels_list: String
  ) {
    updateChannel(
      client_environment_id: $client_environment_id
      update_channels_list: $update_channels_list
      add_channels_list: $add_channels_list
    ) {
      code
      success
      message
      body {
        response
        __typename
      }
      __typename
    }
  }
`;
export const getReports = /* GraphQL */ `
  query GetReports(
    $requester_client_id: String!
    $sortFilter: String
    $sortType: SortType
    $limit: Int
    $offSet: Int
  ) {
    getReports(
      requester_client_id: $requester_client_id
      sortFilter: $sortFilter
      sortType: $sortType
      limit: $limit
      offSet: $offSet
    ) {
      code
      success
      message
      body {
        reportData {
          report_id
          spoke_id
          report_outcome_id
          report_bytes
          viewed
          report_name
          report_type
          report_task_id
          report_outcome_status
          scheduled_start_date
          report_task_status
          report_execution_start_date
          report_execution_end_date
          __typename
        }
        totalCount
        __typename
      }
      __typename
    }
  }
`;
export const getS3PreSignedUrl = /* GraphQL */ `
  query GetS3PreSignedUrl(
    $spoke_id: String!
    $report_outcome_id: String!
    $report_name: String!
    $requester_client_id: String!
  ) {
    getS3PreSignedUrl(
      spoke_id: $spoke_id
      report_outcome_id: $report_outcome_id
      report_name: $report_name
      requester_client_id: $requester_client_id
    ) {
      code
      success
      message
      body {
        report_download_url
        __typename
      }
      __typename
    }
  }
`;
export const updateReportTaskStatus = /* GraphQL */ `
  query UpdateReportTaskStatus(
    $report_task_ids: String!
    $is_viewed: Boolean!
    $requester_client_id: String!
  ) {
    updateReportTaskStatus(
      report_task_ids: $report_task_ids
      is_viewed: $is_viewed
      requester_client_id: $requester_client_id
    ) {
      code
      success
      message
      body {
        response
        __typename
      }
      __typename
    }
  }
`;
export const getCloudWatchMetrics = /* GraphQL */ `
  query GetCloudWatchMetrics(
    $client_environment_id: String!
    $metric_type: String!
    $start: String!
    $end: String!
    $timezone_name: String
    $timezone_offset: String!
  ) {
    getCloudWatchMetrics(
      client_environment_id: $client_environment_id
      metric_type: $metric_type
      start: $start
      end: $end
      timezone_name: $timezone_name
      timezone_offset: $timezone_offset
    ) {
      code
      success
      message
      body {
        metric_widget_image
        __typename
      }
      __typename
    }
  }
`;
export const getClientEnvironmentAuth = /* GraphQL */ `
  query GetClientEnvironmentAuth(
    $client_environment_id: String!
    $auth_type: AuthType!
  ) {
    getClientEnvironmentAuth(
      client_environment_id: $client_environment_id
      auth_type: $auth_type
    ) {
      code
      success
      message
      body {
        response
        __typename
      }
      __typename
    }
  }
`;
export const updateClientEnvironmentAuth = /* GraphQL */ `
  query UpdateClientEnvironmentAuth($auth_json: String!) {
    updateClientEnvironmentAuth(auth_json: $auth_json) {
      code
      success
      message
      body {
        response
        __typename
      }
      __typename
    }
  }
`;
export const deleteClientEnvironment = /* GraphQL */ `
  query DeleteClientEnvironment(
    $client_id: String!
    $deactivate_client: Boolean!
    $aws_client_env_list: [String]
    $db_client_env_list: [String]
  ) {
    deleteClientEnvironment(
      client_id: $client_id
      deactivate_client: $deactivate_client
      aws_client_env_list: $aws_client_env_list
      db_client_env_list: $db_client_env_list
    ) {
      code
      success
      message
      body {
        response
        __typename
      }
      __typename
    }
  }
`;
export const addUser = /* GraphQL */ `
  query AddUser(
    $email_id: String!
    $first_name: String!
    $last_name: String!
    $group: String!
    $custom_attributes: String
    $is_notify: Boolean!
    $is_hidden: Boolean!
    $is_update: Boolean!
    $user_id_to_edit: String
    $permissions: [Permission]
    $requester_client_id: String!
    $resend_invitation: Boolean
  ) {
    addUser(
      email_id: $email_id
      first_name: $first_name
      last_name: $last_name
      group: $group
      custom_attributes: $custom_attributes
      is_notify: $is_notify
      is_hidden: $is_hidden
      is_update: $is_update
      user_id_to_edit: $user_id_to_edit
      permissions: $permissions
      requester_client_id: $requester_client_id
      resend_invitation: $resend_invitation
    ) {
      code
      success
      message
      body {
        response
        __typename
      }
      __typename
    }
  }
`;
export const addMCUser = /* GraphQL */ `
  query AddMCUser(
    $client_environment_id: String!
    $user_id: String!
    $user_email: String!
  ) {
    addMCUser(
      client_environment_id: $client_environment_id
      user_id: $user_id
      user_email: $user_email
    ) {
      code
      success
      message
      body {
        response
        __typename
      }
      __typename
    }
  }
`;
export const addChannel = /* GraphQL */ `
  query AddChannel($name: String!, $file: String!) {
    addChannel(name: $name, file: $file) {
      code
      success
      message
      body {
        channel_library_id
        __typename
      }
      __typename
    }
  }
`;
export const updateChannelLibrary = /* GraphQL */ `
  query UpdateChannelLibrary(
    $id: String!
    $name: String!
    $description: String!
    $tags: [String]
    $channel_type: String!
  ) {
    updateChannelLibrary(
      id: $id
      name: $name
      description: $description
      tags: $tags
      channel_type: $channel_type
    ) {
      code
      success
      message
      body {
        response
        __typename
      }
      __typename
    }
  }
`;
export const getEventAudits = /* GraphQL */ `
  query GetEventAudits(
    $user_id: String
    $event_type_id: [Int]
    $event_type_code_id: [Int]
    $event_action_code_id: [Int]
    $event_outcome_id: [Int]
    $start_date: String
    $end_date: String
    $offSet: Int
    $limit: Int
    $sortFilter: String
    $sortType: SortType
  ) {
    getEventAudits(
      user_id: $user_id
      event_type_id: $event_type_id
      event_type_code_id: $event_type_code_id
      event_action_code_id: $event_action_code_id
      event_outcome_id: $event_outcome_id
      start_date: $start_date
      end_date: $end_date
      offSet: $offSet
      limit: $limit
      sortFilter: $sortFilter
      sortType: $sortType
    ) {
      code
      success
      message
      body {
        event_audit_data {
          audit_event_type_text
          event_action_code_text
          event_outcome_text
          event_type_code_text
          event_idempotency_key
          user_id
          remote_ip
          participant_object_detail
          source_id
          email_id
          event_timestamp
          __typename
        }
        total_count
        __typename
      }
      __typename
    }
  }
`;
export const getAuditSchema = /* GraphQL */ `
  query GetAuditSchema {
    getAuditSchema {
      code
      success
      message
      body {
        audit_event_type {
          label
          value
          event_type_code_id
          event_action_code_id
          __typename
        }
        event_action_code {
          label
          value
          event_type_code_id
          event_action_code_id
          __typename
        }
        event_outcome_code {
          label
          value
          event_type_code_id
          event_action_code_id
          __typename
        }
        event_type_code {
          label
          value
          event_type_code_id
          event_action_code_id
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const getUsers = /* GraphQL */ `
  query GetUsers(
    $email_id: String
    $name: String
    $client_id: String
    $is_hidden: Boolean
    $offSet: Int
    $limit: Int
    $sortFilter: String
    $sortType: SortType
  ) {
    getUsers(
      email_id: $email_id
      name: $name
      client_id: $client_id
      is_hidden: $is_hidden
      offSet: $offSet
      limit: $limit
      sortFilter: $sortFilter
      sortType: $sortType
    ) {
      code
      success
      message
      body {
        user_data {
          user_id
          email_id
          first_name
          last_name
          user_group
          notify_user
          is_hidden
          client_id
          client_name
          created_at
          __typename
        }
        total_count
        __typename
      }
      __typename
    }
  }
`;
export const postChannelActionRequest = /* GraphQL */ `
  query PostChannelActionRequest(
    $client_environment_id: String!
    $suppress_list: [String]
    $unsuppress_list: [String]
    $delete_resource_list: [String]
    $delete_db_list: [String]
  ) {
    postChannelActionRequest(
      client_environment_id: $client_environment_id
      suppress_list: $suppress_list
      unsuppress_list: $unsuppress_list
      delete_resource_list: $delete_resource_list
      delete_db_list: $delete_db_list
    ) {
      code
      success
      message
      body {
        response
        __typename
      }
      __typename
    }
  }
`;
export const postClientEnvironmentActionRequest = /* GraphQL */ `
  query PostClientEnvironmentActionRequest(
    $suppress_list: [String]
    $unsuppress_list: [String]
    $delete_resource_list: [String]
    $delete_db_hub_list: [String]
    $delete_db_spoke_list: [String]
  ) {
    postClientEnvironmentActionRequest(
      suppress_list: $suppress_list
      unsuppress_list: $unsuppress_list
      delete_resource_list: $delete_resource_list
      delete_db_hub_list: $delete_db_hub_list
      delete_db_spoke_list: $delete_db_spoke_list
    ) {
      code
      success
      message
      body {
        response
        __typename
      }
      __typename
    }
  }
`;
export const clientCleanup = /* GraphQL */ `
  query ClientCleanup($clientId: String) {
    clientCleanup(clientId: $clientId) {
      code
      success
      message
      body {
        response
        __typename
      }
      __typename
    }
  }
`;
export const cypressCleanup = /* GraphQL */ `
  query CypressCleanup(
    $clientId: String!
    $clientEnvironmentId: String!
    $channels: [String!]
    $users: [String!]
  ) {
    cypressCleanup(
      clientId: $clientId
      clientEnvironmentId: $clientEnvironmentId
      channels: $channels
      users: $users
    ) {
      code
      success
      message
      body {
        response
        __typename
      }
      __typename
    }
  }
`;
export const getChannelLibrary = /* GraphQL */ `
  query GetChannelLibrary(
    $channel_library_id_list: [String]
    $channel_library_name_list: [String]
    $description_list: [String]
    $channel_type_list: [String]
    $tag_list: [String]
    $offSet: Int
    $limit: Int
    $sortFilter: String
    $sortType: SortType
  ) {
    getChannelLibrary(
      channel_library_id_list: $channel_library_id_list
      channel_library_name_list: $channel_library_name_list
      description_list: $description_list
      channel_type_list: $channel_type_list
      tag_list: $tag_list
      offSet: $offSet
      limit: $limit
      sortFilter: $sortFilter
      sortType: $sortType
    ) {
      code
      success
      message
      body {
        channel_library_data {
          channel_library_id
          channel_library_name
          description
          s3_location
          mcc_channel_type
          created_date
          modified_date
          created_by
          modified_by
          mc_version
          tag_list
          count
          __typename
        }
        total_count
        __typename
      }
      __typename
    }
  }
`;
export const getChannelXML = /* GraphQL */ `
  query GetChannelXML($channel_library_id: String!) {
    getChannelXML(channel_library_id: $channel_library_id) {
      code
      success
      message
      body {
        channel_library_id
        channel_xml
        __typename
      }
      __typename
    }
  }
`;
export const getBatches = /* GraphQL */ `
  query GetBatches(
    $start_date: String
    $end_date: String
    $batch_status: String
    $client_ids: [String]
    $environment_ids: [String]
    $channel_ids: [String]
    $spoke_ids: [String]
    $show_batch_with_errors: Boolean
    $offSet: Int
    $limit: Int!
    $sortFilter: String
    $sortType: SortType
  ) {
    getBatches(
      start_date: $start_date
      end_date: $end_date
      batch_status: $batch_status
      client_ids: $client_ids
      environment_ids: $environment_ids
      channel_ids: $channel_ids
      spoke_ids: $spoke_ids
      show_batch_with_errors: $show_batch_with_errors
      offSet: $offSet
      limit: $limit
      sortFilter: $sortFilter
      sortType: $sortType
    ) {
      code
      success
      message
      body {
        batches {
          batch_id
          client_id
          client_name
          client_environment_id
          client_environment_name
          channel_id
          channel_name
          spoke_id
          spoke_name
          email_id
          batch_timestamp
          batch_total
          batch_success
          batch_errors
          batch_pending
          __typename
        }
        total_count
        __typename
      }
      __typename
    }
  }
`;
export const deleteClient = /* GraphQL */ `
  query DeleteClient($client_id: String) {
    deleteClient(client_id: $client_id) {
      code
      success
      message
      body {
        response
        __typename
      }
      __typename
    }
  }
`;
export const getBatchDetails = /* GraphQL */ `
  query GetBatchDetails(
    $client_environment_id: String
    $client_id: String
    $batch_id: String
    $offSet: Int
    $limit: Int
    $sortFilter: String
    $sortType: SortType
    $messageStatus: [String]
  ) {
    getBatchDetails(
      client_environment_id: $client_environment_id
      client_id: $client_id
      batch_id: $batch_id
      offSet: $offSet
      limit: $limit
      sortFilter: $sortFilter
      sortType: $sortType
      messageStatus: $messageStatus
    ) {
      code
      success
      message
      body {
        message_batch_data {
          client_id
          client_name
          client_environment_id
          client_environment_name
          channel_id
          channel_name
          batch_id
          email_id
          batch_timestamp
          message_batch_details_data {
            new_message_id
            new_inbound_message_idempotency_key
            original_message_id
            original_inbound_message_idempotency_key
            message_data_available
            reprocess_status_text
            error_total
            filter_total
            sent_total
            reprocess_timestamp
            reprocess_details
            __typename
          }
          __typename
        }
        total_message_batch_count
        __typename
      }
      __typename
    }
  }
`;
export const promptAssistantChannelError = /* GraphQL */ `
  query PromptAssistantChannelError(
    $prompt: String!
    $session_id: String
    $client_id: String!
    $client_environment_id: String!
    $channel_id: String!
    $inbound_message_idempotency_key: String
  ) {
    promptAssistantChannelError(
      prompt: $prompt
      session_id: $session_id
      client_id: $client_id
      client_environment_id: $client_environment_id
      channel_id: $channel_id
      inbound_message_idempotency_key: $inbound_message_idempotency_key
    ) {
      code
      success
      message
      body {
        response
        sessionId
        prompt_token_count
        generation_token_count
        guardrail_action
        __typename
      }
      __typename
    }
  }
`;
export const addEulaUserConsent = /* GraphQL */ `
  query AddEulaUserConsent($eula_version_id: Int!) {
    addEulaUserConsent(eula_version_id: $eula_version_id) {
      code
      success
      message
      body {
        response
        __typename
      }
      __typename
    }
  }
`;
export const fetchEulaUserConsent = /* GraphQL */ `
  query FetchEulaUserConsent {
    fetchEulaUserConsent {
      code
      success
      message
      body {
        eula_version_id
        acceptance_timestamp
        __typename
      }
      __typename
    }
  }
`;
export const fetchCurrentEula = /* GraphQL */ `
  query FetchCurrentEula {
    fetchCurrentEula {
      code
      success
      message
      body {
        eula_version_id
        content
        content_type
        __typename
      }
      __typename
    }
  }
`;
export const getCurrentECRVersion = /* GraphQL */ `
  query GetCurrentECRVersion(
    $available_type: String!
    $requester_client_id: String!
  ) {
    getCurrentECRVersion(
      available_type: $available_type
      requester_client_id: $requester_client_id
    ) {
      code
      success
      message
      body {
        version_number
        ecr_image_uri
        position
        __typename
      }
      __typename
    }
  }
`;
export const getKeygenClientSearch = /* GraphQL */ `
  query GetKeygenClientSearch(
    $client_name: String
    $sap_id: String
    $mc_license_key: String
    $sortFilter: String
    $sortType: SortType
    $limit: Int
    $offSet: Int
  ) {
    getKeygenClientSearch(
      client_name: $client_name
      sap_id: $sap_id
      mc_license_key: $mc_license_key
      sortFilter: $sortFilter
      sortType: $sortType
      limit: $limit
      offSet: $offSet
    ) {
      code
      success
      message
      body {
        keygen_client_search_data {
          keygen_id
          keygen_key
          keygen_expiry
          keygen_customer_id
          keygen_customer_name
          keygen_name
          __typename
        }
        total_count
        __typename
      }
      __typename
    }
  }
`;
export const getUser = /* GraphQL */ `
  query GetUser($user_id: String) {
    getUser(user_id: $user_id) {
      code
      success
      message
      body {
        email_id
        first_name
        last_name
        client_id
        client_name
        notify_user
        user_group
        is_hidden
        permissions
        __typename
      }
      __typename
    }
  }
`;
export const addScheduledReport = /* GraphQL */ `
  query AddScheduledReport(
    $report_name: String!
    $report_distribution: Int!
    $created_by_user_org: String
    $report_run_date: String!
    $report_parameters: String
    $report_type: String!
    $requested_environments: [String]
  ) {
    addScheduledReport(
      report_name: $report_name
      report_distribution: $report_distribution
      created_by_user_org: $created_by_user_org
      report_run_date: $report_run_date
      report_parameters: $report_parameters
      report_type: $report_type
      requested_environments: $requested_environments
    ) {
      code
      success
      message
      body {
        response
        __typename
      }
      __typename
    }
  }
`;
export const refreshChannelTokens = /* GraphQL */ `
  query RefreshChannelTokens($client_environment_id: String!) {
    refreshChannelTokens(client_environment_id: $client_environment_id) {
      code
      success
      message
      body {
        response
        __typename
      }
      __typename
    }
  }
`;
export const getUserBadges = /* GraphQL */ `
  query GetUserBadges($requester_client_id: String!) {
    getUserBadges(requester_client_id: $requester_client_id) {
      code
      success
      message
      body {
        unviewed_reports_count
        __typename
      }
      __typename
    }
  }
`;
export const updateClientName = /* GraphQL */ `
  query UpdateClientName($client_id: String!, $client_name: String!) {
    updateClientName(client_id: $client_id, client_name: $client_name) {
      code
      success
      message
      body {
        response
        __typename
      }
      __typename
    }
  }
`;
export const updateClientEnvironmentName = /* GraphQL */ `
  query UpdateClientEnvironmentName(
    $client_environment_id: String!
    $client_environment_name: String!
  ) {
    updateClientEnvironmentName(
      client_environment_id: $client_environment_id
      client_environment_name: $client_environment_name
    ) {
      code
      success
      message
      body {
        response
        __typename
      }
      __typename
    }
  }
`;
export const getMCServerInfo = /* GraphQL */ `
  query GetMCServerInfo(
    $last_updated_start_date: String
    $last_updated_end_date: String
    $client_ids: [String]
    $environment_ids: [String]
    $mirth_connect_version: [String]
    $offSet: Int
    $limit: Int
    $sortFilter: String
    $sortType: SortType
  ) {
    getMCServerInfo(
      last_updated_start_date: $last_updated_start_date
      last_updated_end_date: $last_updated_end_date
      client_ids: $client_ids
      environment_ids: $environment_ids
      mirth_connect_version: $mirth_connect_version
      offSet: $offSet
      limit: $limit
      sortFilter: $sortFilter
      sortType: $sortType
    ) {
      code
      success
      message
      body {
        mcServerInfo {
          client_name
          client_environment_name
          mc_server_name
          mc_server_id
          mc_version
          mc_time
          mc_timezone
          os_name
          os_version
          os_architecture
          jvm_version
          db_name
          db_version
          last_updated
          __typename
        }
        totalCount
        __typename
      }
      __typename
    }
  }
`;
export const getLicensesAndEntitlements = /* GraphQL */ `
  query GetLicensesAndEntitlements($client_id: String!) {
    getLicensesAndEntitlements(client_id: $client_id) {
      code
      success
      message
      body {
        client_name
        Entitlements {
          entitlement_id
          license_id
          entitlement_type
          client_id
          allotment
          total_usage
          __typename
        }
        Licenses {
          license_key_id
          keygen_key
          keygen_id
          expiration
          revoked
          license_id
          license_key_name
          environments {
            client_environment_id
            client_environment_name
            client_environment_type
            deploy_status
            __typename
          }
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const getEntitlementUsages = /* GraphQL */ `
  query GetEntitlementUsages(
    $client_id: String!
    $client_environment_id: String
  ) {
    getEntitlementUsages(
      client_id: $client_id
      client_environment_id: $client_environment_id
    ) {
      code
      success
      message
      body {
        EntitlementUsages {
          entitlement_type
          client_environment_name
          channel_name
          __typename
        }
        totalCount
        __typename
      }
      __typename
    }
  }
`;
export const addLicense = /* GraphQL */ `
  query AddLicense($client_id: String!, $license_details: String!) {
    addLicense(client_id: $client_id, license_details: $license_details) {
      code
      success
      message
      body {
        response
        __typename
      }
      __typename
    }
  }
`;
export const retrieveLicenseKey = /* GraphQL */ `
  query RetrieveLicenseKey($client_id: String!, $license_key_id: String!) {
    retrieveLicenseKey(client_id: $client_id, license_key_id: $license_key_id) {
      code
      success
      message
      body {
        keygen_key
        __typename
      }
      __typename
    }
  }
`;
export const revokeLicenseKey = /* GraphQL */ `
  query RevokeLicenseKey($client_id: String!, $license_key_id: String!) {
    revokeLicenseKey(client_id: $client_id, license_key_id: $license_key_id) {
      code
      success
      message
      body {
        response
        __typename
      }
      __typename
    }
  }
`;
export const getChannelConfigurations = /* GraphQL */ `
  query GetChannelConfigurations($client_environment_id: String!) {
    getChannelConfigurations(client_environment_id: $client_environment_id) {
      code
      success
      message
      body {
        channel_configurations {
          id
          path
          http_auth_type
          port
          channel_library_id
          channel_library_name
          type
          queue_yellow
          queue_red
          error_yellow
          error_red
          inactivity_yellow
          inactivity_red
          poll_frequency
          support_tier
          mc_pruning_metadata
          mc_pruning_metadata_days
          mc_prune_content_days
          mc_prune_errored_messages
          mc_message_storage_mode
          tmp_recommended
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const getClientEntitlements = /* GraphQL */ `
  query GetClientEntitlements($client_id: String!) {
    getClientEntitlements(client_id: $client_id) {
      code
      success
      message
      body {
        client_id
        client_name
        license_id
        entitlements {
          type
          allotment
          used
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const updateClientEntitlements = /* GraphQL */ `
  query UpdateClientEntitlements(
    $client_id: String!
    $license_id: Int!
    $entitlements: String
  ) {
    updateClientEntitlements(
      client_id: $client_id
      license_id: $license_id
      entitlements: $entitlements
    ) {
      code
      success
      message
      body {
        response
        __typename
      }
      __typename
    }
  }
`;
export const getClientEnvironmentEntitlementsAvailable = /* GraphQL */ `
  query GetClientEnvironmentEntitlementsAvailable(
    $client_environment_id: String!
  ) {
    getClientEnvironmentEntitlementsAvailable(
      client_environment_id: $client_environment_id
    ) {
      code
      success
      message
      body {
        client_name
        client_environment_id
        client_environment_name
        entitlements_available {
          type
          entitlement_id
          allotment
          used
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const getChannelEntitlementUsage = /* GraphQL */ `
  query GetChannelEntitlementUsage($client_environment_id: String!) {
    getChannelEntitlementUsage(client_environment_id: $client_environment_id) {
      code
      success
      message
      body {
        channel_name
        channel_id
        channel_group
        entitlement_types
        __typename
      }
      __typename
    }
  }
`;
export const updateChannelEntitlementUsage = /* GraphQL */ `
  query UpdateChannelEntitlementUsage(
    $client_environment_id: String!
    $add_list: String!
    $delete_list: String!
  ) {
    updateChannelEntitlementUsage(
      client_environment_id: $client_environment_id
      add_list: $add_list
      delete_list: $delete_list
    ) {
      code
      success
      message
      body {
        response
        __typename
      }
      __typename
    }
  }
`;
export const unregisterEnvironment = /* GraphQL */ `
  query UnregisterEnvironment($client_environment_id: String!) {
    unregisterEnvironment(client_environment_id: $client_environment_id) {
      code
      success
      message
      body {
        response
        __typename
      }
      __typename
    }
  }
`;
export const getSpokes = /* GraphQL */ `
  query GetSpokes {
    getSpokes {
      code
      success
      message
      body {
        spoke_id
        spoke_name
        spoke_type
        region
        api_request_url
        api_role
        aws_account
        ecr_repo
        __typename
      }
      __typename
    }
  }
`;
export const getClientEnvironmentDefaultThreshold = /* GraphQL */ `
  query GetClientEnvironmentDefaultThreshold($client_id: String!) {
    getClientEnvironmentDefaultThreshold(client_id: $client_id) {
      code
      success
      message
      body {
        mc_prune_enabled
        mc_polling_type
        mc_polling_frequency_min
        mc_polling_frequency_max
        mc_all_day
        mc_starting_hour
        mc_ending_hour
        mc_prune_events
        mc_prune_event_age
        first_name
        last_name
        active_start_date
        __typename
      }
      __typename
    }
  }
`;
export const updateClientEnvironmentDefaultThreshold = /* GraphQL */ `
  query UpdateClientEnvironmentDefaultThreshold(
    $client_id: String!
    $mc_prune_enabled: Boolean!
    $mc_polling_type: String
    $mc_polling_frequency_min: Int
    $mc_polling_frequency_max: Int
    $mc_all_day: Boolean!
    $mc_starting_hour: Int
    $mc_ending_hour: Int
    $mc_prune_events: Boolean!
    $mc_prune_event_age: Int
  ) {
    updateClientEnvironmentDefaultThreshold(
      client_id: $client_id
      mc_prune_enabled: $mc_prune_enabled
      mc_polling_type: $mc_polling_type
      mc_polling_frequency_min: $mc_polling_frequency_min
      mc_polling_frequency_max: $mc_polling_frequency_max
      mc_all_day: $mc_all_day
      mc_starting_hour: $mc_starting_hour
      mc_ending_hour: $mc_ending_hour
      mc_prune_events: $mc_prune_events
      mc_prune_event_age: $mc_prune_event_age
    ) {
      code
      success
      message
      body {
        response
        __typename
      }
      __typename
    }
  }
`;
export const getChannelDefaultThreshold = /* GraphQL */ `
  query GetChannelDefaultThreshold($client_id: String!) {
    getChannelDefaultThreshold(client_id: $client_id) {
      code
      success
      message
      body {
        queue_yellow
        queue_red
        error_yellow
        error_red
        poll_frequency
        inactivity_yellow
        inactivity_red
        support_tier
        mc_pruning_metadata
        mc_pruning_metadata_days
        mc_prune_content_days
        mc_prune_errored_messages
        mc_message_storage_mode
        mc_check_channel_metadata
        active_start_date
        __typename
      }
      __typename
    }
  }
`;
export const updateChannelDefaultThreshold = /* GraphQL */ `
  query UpdateChannelDefaultThreshold(
    $client_id: String!
    $queue_yellow: Int
    $queue_red: Int
    $error_yellow: Int
    $error_red: Int
    $poll_frequency: Int
    $inactivity_yellow: Int
    $inactivity_red: Int
    $support_tier: Int
    $mc_pruning_metadata: Boolean
    $mc_pruning_metadata_days: Int
    $mc_prune_content_days: Int
    $mc_prune_errored_messages: Boolean
    $mc_message_storage_mode: String
    $mc_check_channel_metadata: Boolean
  ) {
    updateChannelDefaultThreshold(
      client_id: $client_id
      queue_yellow: $queue_yellow
      queue_red: $queue_red
      error_yellow: $error_yellow
      error_red: $error_red
      poll_frequency: $poll_frequency
      inactivity_yellow: $inactivity_yellow
      inactivity_red: $inactivity_red
      support_tier: $support_tier
      mc_pruning_metadata: $mc_pruning_metadata
      mc_pruning_metadata_days: $mc_pruning_metadata_days
      mc_prune_content_days: $mc_prune_content_days
      mc_prune_errored_messages: $mc_prune_errored_messages
      mc_message_storage_mode: $mc_message_storage_mode
      mc_check_channel_metadata: $mc_check_channel_metadata
    ) {
      code
      success
      message
      body {
        response
        __typename
      }
      __typename
    }
  }
`;
export const updateAllChannelsToDefaultThreshold = /* GraphQL */ `
  query UpdateAllChannelsToDefaultThreshold(
    $client_id: String!
    $queue_yellow: Int
    $queue_red: Int
    $error_yellow: Int
    $error_red: Int
    $poll_frequency: Int
    $inactivity_yellow: Int
    $inactivity_red: Int
    $support_tier: Int
    $mc_pruning_metadata: Boolean
    $mc_pruning_metadata_days: Int
    $mc_prune_content_days: Int
    $mc_prune_errored_messages: Boolean
    $mc_message_storage_mode: String
    $mc_check_channel_metadata: Boolean
  ) {
    updateAllChannelsToDefaultThreshold(
      client_id: $client_id
      queue_yellow: $queue_yellow
      queue_red: $queue_red
      error_yellow: $error_yellow
      error_red: $error_red
      poll_frequency: $poll_frequency
      inactivity_yellow: $inactivity_yellow
      inactivity_red: $inactivity_red
      support_tier: $support_tier
      mc_pruning_metadata: $mc_pruning_metadata
      mc_pruning_metadata_days: $mc_pruning_metadata_days
      mc_prune_content_days: $mc_prune_content_days
      mc_prune_errored_messages: $mc_prune_errored_messages
      mc_message_storage_mode: $mc_message_storage_mode
      mc_check_channel_metadata: $mc_check_channel_metadata
    ) {
      code
      success
      message
      body {
        response
        __typename
      }
      __typename
    }
  }
`;
export const updateAllClientEnvironmentsToDefaultThreshold = /* GraphQL */ `
  query UpdateAllClientEnvironmentsToDefaultThreshold(
    $client_id: String!
    $mc_prune_enabled: Boolean!
    $mc_polling_type: String
    $mc_polling_frequency_min: Int
    $mc_polling_frequency_max: Int
    $mc_all_day: Boolean!
    $mc_starting_hour: Int
    $mc_ending_hour: Int
    $mc_prune_events: Boolean!
    $mc_prune_event_age: Int
  ) {
    updateAllClientEnvironmentsToDefaultThreshold(
      client_id: $client_id
      mc_prune_enabled: $mc_prune_enabled
      mc_polling_type: $mc_polling_type
      mc_polling_frequency_min: $mc_polling_frequency_min
      mc_polling_frequency_max: $mc_polling_frequency_max
      mc_all_day: $mc_all_day
      mc_starting_hour: $mc_starting_hour
      mc_ending_hour: $mc_ending_hour
      mc_prune_events: $mc_prune_events
      mc_prune_event_age: $mc_prune_event_age
    ) {
      code
      success
      message
      body {
        response
        __typename
      }
      __typename
    }
  }
`;
export const getMCECRAuth = /* GraphQL */ `
  query GetMCECRAuth($requester_client_id: String!) {
    getMCECRAuth(requester_client_id: $requester_client_id) {
      code
      success
      message
      body {
        username
        token
        __typename
      }
      __typename
    }
  }
`;
export const getMCDockerImages = /* GraphQL */ `
  query GetMCDockerImages(
    $requester_client_id: String!
    $sortFilter: String
    $sortType: SortType
    $limit: Int
    $offSet: Int
  ) {
    getMCDockerImages(
      requester_client_id: $requester_client_id
      sortFilter: $sortFilter
      sortType: $sortType
      limit: $limit
      offSet: $offSet
    ) {
      code
      success
      message
      body {
        awsAccountId
        mcDockerImagesData {
          image_name
          display_name
          mc_version
          base_image
          java_version
          architecture
          description
          position
          __typename
        }
        totalCount
        __typename
      }
      __typename
    }
  }
`;
export const getArchivedMessageMetadata = /* GraphQL */ `
  query GetArchivedMessageMetadata(
    $clientEnvironmentId: String!
    $channelId: String!
    $msgId: String!
    $msgStatus: String!
    $startDate: String!
    $endDate: String!
    $customMetadata: String
    $offSet: Int
    $limit: Int
    $sortFilter: String
    $sortType: SortType
    $isFirstFind: Boolean
  ) {
    getArchivedMessageMetadata(
      clientEnvironmentId: $clientEnvironmentId
      channelId: $channelId
      msgId: $msgId
      msgStatus: $msgStatus
      startDate: $startDate
      endDate: $endDate
      customMetadata: $customMetadata
      offSet: $offSet
      limit: $limit
      sortFilter: $sortFilter
      sortType: $sortType
      isFirstFind: $isFirstFind
    ) {
      code
      success
      message
      body {
        archivedMessages {
          manifest_id
          is_bundle
          archive_bundle_path
          msg_id
          sent_total
          error_total
          filter_total
          message_bundle_details {
            attachment_path
            message_path
            metadata_path
            __typename
          }
          flat_message_details {
            attachment_path
            message_path
            metadata_path
            __typename
          }
          raw_message_bytes
          date_received
          date_rollup
          __typename
        }
        totalCount
        __typename
      }
      __typename
    }
  }
`;
export const getArchivedMessageManifest = /* GraphQL */ `
  query GetArchivedMessageManifest(
    $clientEnvironmentId: String!
    $channelId: String!
    $messageId: Int!
    $manifestId: String!
    $dateRollup: String!
  ) {
    getArchivedMessageManifest(
      clientEnvironmentId: $clientEnvironmentId
      channelId: $channelId
      messageId: $messageId
      manifestId: $manifestId
      dateRollup: $dateRollup
    ) {
      code
      success
      message
      body {
        environment_id
        channel_id
        manifest_id
        is_bundle
        msg_id
        sent_total
        error_total
        filter_total
        raw_message_bytes
        date_received
        date_completed
        date_rollup
        archive_bundle_path
        message_bundle_details {
          attachment_path
          message_path
          metadata_path
          __typename
        }
        flat_message_details {
          attachment_path
          message_path
          metadata_path
          __typename
        }
        connector_details {
          connector_id
          connector_name
          connector_status
          connector_error_text
          __typename
        }
        raw_data {
          attachment
          message
          metadata
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const getMirthTasks = /* GraphQL */ `
  query GetMirthTasks(
    $client_id: String
    $client_environment_ids: [String]
    $status: [Int]
    $outcome: [Int]
    $task_type: [String]
    $start_date: String
    $end_date: String
    $offSet: Int
    $limit: Int
    $sortFilter: String
    $sortType: SortType
  ) {
    getMirthTasks(
      client_id: $client_id
      client_environment_ids: $client_environment_ids
      status: $status
      outcome: $outcome
      task_type: $task_type
      start_date: $start_date
      end_date: $end_date
      offSet: $offSet
      limit: $limit
      sortFilter: $sortFilter
      sortType: $sortType
    ) {
      code
      success
      message
      body {
        mirthTasks {
          cloud_task_id
          client_name
          environment_name
          client_id
          client_environment_id
          created_at
          updated_at
          date_rollup
          status
          outcome
          task_type
          subject
          first_name
          last_name
          __typename
        }
        totalCount
        __typename
      }
      __typename
    }
  }
`;
export const invokeMCTask = /* GraphQL */ `
  query InvokeMCTask(
    $client_id: String!
    $client_environment_id: String!
    $subject: String!
    $task_type: String!
    $mcc_preparation_data: String
    $mc_task_data: String
    $mcc_cleanup_data: String
    $needs_preparation: Boolean!
    $needs_cleanup: Boolean!
  ) {
    invokeMCTask(
      client_id: $client_id
      client_environment_id: $client_environment_id
      subject: $subject
      task_type: $task_type
      mcc_preparation_data: $mcc_preparation_data
      mc_task_data: $mc_task_data
      mcc_cleanup_data: $mcc_cleanup_data
      needs_preparation: $needs_preparation
      needs_cleanup: $needs_cleanup
    ) {
      code
      success
      message
      body {
        task_id
        __typename
      }
      __typename
    }
  }
`;
export const invokeMCResendMessagesTask = /* GraphQL */ `
  query InvokeMCResendMessagesTask(
    $client_id: String!
    $client_environment_id: String!
    $task_data: String!
    $task_object_data: String!
  ) {
    invokeMCResendMessagesTask(
      client_id: $client_id
      client_environment_id: $client_environment_id
      task_data: $task_data
      task_object_data: $task_object_data
    ) {
      code
      success
      message
      body {
        task_id
        __typename
      }
      __typename
    }
  }
`;
export const invokeMCCDeleteMessagesTask = /* GraphQL */ `
  query InvokeMCCDeleteMessagesTask(
    $client_id: String!
    $delete_messages_payload: [DeleteMessagesObject]!
  ) {
    invokeMCCDeleteMessagesTask(
      client_id: $client_id
      delete_messages_payload: $delete_messages_payload
    ) {
      code
      success
      message
      body {
        cloud_task_ids
        skipped_environments {
          environment_id
          environment_name
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const invokeMCCExportMessagesTask = /* GraphQL */ `
  query InvokeMCCExportMessagesTask($environment_ids: [String!]!) {
    invokeMCCExportMessagesTask(environment_ids: $environment_ids) {
      code
      success
      message
      body {
        cloud_task_ids
        skipped_environments {
          environment_id
          environment_name
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const getMirthResendTaskDetails = /* GraphQL */ `
  query GetMirthResendTaskDetails(
    $clientEnvironmentId: String!
    $cloudTaskId: String!
    $dateRollup: String!
    $limit: Int!
    $offset: Int
    $accurateTotal: Boolean
    $messageId: String
    $msgResendStatuses: [String]
    $sortFilter: String
    $sortType: SortType
  ) {
    getMirthResendTaskDetails(
      clientEnvironmentId: $clientEnvironmentId
      cloudTaskId: $cloudTaskId
      dateRollup: $dateRollup
      limit: $limit
      offset: $offset
      accurateTotal: $accurateTotal
      messageId: $messageId
      msgResendStatuses: $msgResendStatuses
      sortFilter: $sortFilter
      sortType: $sortType
    ) {
      code
      success
      message
      body {
        task_id
        environment_id
        channel_id
        environment_name
        client_name
        channel_name
        resend_manifest_id
        sent_total
        error_total
        total_count
        messages {
          message_id
          original_message_id
          message_type
          message_status
          mc_message_status
          message_date_received
          message_date_completed
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const getMirthMessageDetails = /* GraphQL */ `
  query GetMirthMessageDetails(
    $clientEnvironmentId: String!
    $cloudTaskId: String!
    $dateRollup: String!
    $channelId: String!
    $messageId: Int!
  ) {
    getMirthMessageDetails(
      clientEnvironmentId: $clientEnvironmentId
      cloudTaskId: $cloudTaskId
      dateRollup: $dateRollup
      channelId: $channelId
      messageId: $messageId
    ) {
      code
      success
      message
      body {
        task_id
        environment_id
        channel_id
        resend_manifest_id
        message_id
        original_message_id
        sent_total
        error_total
        message_type
        message_status
        message_date_received
        message_date_completed
        connector_details {
          connector_id
          connector_status
          connector_error_text
          __typename
        }
        environment_name
        client_name
        channel_name
        __typename
      }
      __typename
    }
  }
`;
export const getFavoriteChannels = /* GraphQL */ `
  query GetFavoriteChannels(
    $client_id: String!
    $client_environment_id: String
    $metric_date_range_list: String
    $offSet: Int
    $limit: Int
    $sortFilter: String
    $sortType: SortType
  ) {
    getFavoriteChannels(
      client_id: $client_id
      client_environment_id: $client_environment_id
      metric_date_range_list: $metric_date_range_list
      offSet: $offSet
      limit: $limit
      sortFilter: $sortFilter
      sortType: $sortType
    ) {
      code
      success
      message
      body {
        favorite_channels {
          channel_id
          channel_name
          client_environment_name
          spoke_type
          client_environment_id
          channel_status
          suppress_support_event
          channel_group_name
          mc_auth_type
          received_messages
          sent_messages
          errored_messages
          filtered_messages
          queued_messages
          last_reviewed_by_support
          support_tier
          avg_process_time
          last_calculated
          mcc_channel_type
          enabled
          __typename
        }
        count
        __typename
      }
      __typename
    }
  }
`;
export const updateFavoriteChannels = /* GraphQL */ `
  query UpdateFavoriteChannels(
    $client_id: String!
    $client_environment_id: String!
    $favorite_channel_id: String!
    $is_add_favorite: Boolean!
  ) {
    updateFavoriteChannels(
      client_id: $client_id
      client_environment_id: $client_environment_id
      favorite_channel_id: $favorite_channel_id
      is_add_favorite: $is_add_favorite
    ) {
      code
      success
      message
      body {
        response
        __typename
      }
      __typename
    }
  }
`;
export const getMCCTaskDeleteMessagesDetails = /* GraphQL */ `
  query GetMCCTaskDeleteMessagesDetails($cloud_task_id: String!) {
    getMCCTaskDeleteMessagesDetails(cloud_task_id: $cloud_task_id) {
      code
      success
      message
      body {
        cloud_task_id
        client_id
        client_name
        client_environment_id
        client_environment_name
        created_at
        updated_at
        status
        outcome
        subject
        user_id
        message
        error
        deleted_size
        delete_job_id
        deleted_count
        total_prefixes
        completed_prefixes
        details {
          channel_name
          channel_id
          date_rollup
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const getMCCTaskExportMessagesDetails = /* GraphQL */ `
  query GetMCCTaskExportMessagesDetails($cloud_task_id: String!) {
    getMCCTaskExportMessagesDetails(cloud_task_id: $cloud_task_id) {
      code
      success
      message
      body {
        cloud_task_id
        client_id
        client_name
        client_environment_id
        client_environment_name
        created_at
        updated_at
        status
        outcome
        subject
        user_id
        message
        destination
        error
        __typename
      }
      __typename
    }
  }
`;
export const getExportMessagesDownloadURL = /* GraphQL */ `
  query GetExportMessagesDownloadURL($cloud_task_id: String!) {
    getExportMessagesDownloadURL(cloud_task_id: $cloud_task_id) {
      code
      success
      message
      body {
        download_url
        __typename
      }
      __typename
    }
  }
`;
export const getWhitelistedCIDRs = /* GraphQL */ `
  query GetWhitelistedCIDRs($client_environment_id: String!) {
    getWhitelistedCIDRs(client_environment_id: $client_environment_id) {
      code
      success
      message
      body {
        ipv4_cidrs {
          cidrs {
            cidr
            note
            __typename
          }
          lock_token
          __typename
        }
        ipv6_cidrs {
          cidrs {
            cidr
            note
            __typename
          }
          lock_token
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const addWhitelistCIDR = /* GraphQL */ `
  query AddWhitelistCIDR(
    $client_environment_id: String!
    $ip_address_version: IpAddressVersion!
    $cidr: String!
    $note: String
    $lock_token: String!
  ) {
    addWhitelistCIDR(
      client_environment_id: $client_environment_id
      ip_address_version: $ip_address_version
      cidr: $cidr
      note: $note
      lock_token: $lock_token
    ) {
      code
      success
      message
      body {
        message
        next_lock_token
        __typename
      }
      __typename
    }
  }
`;
export const deleteWhitelistedCIDR = /* GraphQL */ `
  query DeleteWhitelistedCIDR(
    $client_environment_id: String!
    $ip_address_version: IpAddressVersion!
    $cidrs: [String]!
    $lock_token: String!
  ) {
    deleteWhitelistedCIDR(
      client_environment_id: $client_environment_id
      ip_address_version: $ip_address_version
      cidrs: $cidrs
      lock_token: $lock_token
    ) {
      code
      success
      message
      body {
        message
        next_lock_token
        __typename
      }
      __typename
    }
  }
`;
export const getFirewallLogs = /* GraphQL */ `
  query GetFirewallLogs(
    $client_environment_id: String!
    $start_date: String!
    $end_date: String!
    $limit: Int
  ) {
    getFirewallLogs(
      client_environment_id: $client_environment_id
      start_date: $start_date
      end_date: $end_date
      limit: $limit
    ) {
      code
      success
      message
      body {
        acl_logs {
          timestamp
          reason
          http_method
          http_url
          ip
          country
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
